import Navbar from "../navbar/navbar";

const DashBoardComponent = () => {
      return (
        <div>
            <Navbar/>
            <h1>Welcome to Dashboard</h1>
        </div>
      )
};

export default DashBoardComponent;